import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'HeroFullOverlayInnerContent',
})(({ typography: { pxToRem }, spacing, brandColors, type, breakpoints }) => ({
  onDark: {
    '& .primaryTextColor': {
      color: brandColors.white,
    },
    '& .accentTextColor': {
      color: brandColors.tintsOffWhite40,
    },
  },
  onLight: {
    '& .primaryTextColor': {
      color: brandColors.black,
    },
    '& .accentTextColor': {
      color: brandColors.tintsNeutral20,
    },
  },
  flex: {
    display: 'flex',
  },
  flexCol: {
    display: 'flex',
    flexDirection: 'column',
  },
  centerItems: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  gapMinusOne: {
    gap: spacing(-1),
  },
  gapOne: {
    gap: spacing(1),
  },
  gapTwo: {
    gap: spacing(2),
  },
  bulletedList: {
    paddingLeft: pxToRem(35),
    textAlign: 'left',

    '& li': {
      '&:not(:last-child)': {
        marginBottom: spacing(-1),
      },
    },
  },
  termsAndConditionsText: {
    textDecoration: 'none',
  },

  // custom type setup for slide mode
  heading: {
    [breakpoints.up('xs')]: { ...type['40_medium'] },
    [breakpoints.up('lg')]: { ...type['64_medium'] },
  },
  subheading: {
    [breakpoints.up('xs')]: { ...type['18_regular'] },
    [breakpoints.up('lg')]: { ...type['24_regular'] },
  },
}));

export default useStyles;
